import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import { creator } from 'uwork-app-core';
import axios from 'utils/axios';

/**
 * External Ations
 */

import { actions as workersAction } from 'sagas/app/workers/workersSaga';
import { actions as profileActions } from 'sagas/app/workers/workersProfileSaga';

/**
 * Constants
 */
export const REQUEST = '@app/orders/updateworkerstagesaga/REQUEST';
export const SUCCESS = '@app/orders/updateworkerstagesaga/SUCCESS';
export const FAILURE = '@app/orders/updateworkerstagesaga/FAILURE';
export const SET_LOADING = '@app/orders/updateworkerstagesaga/SET_LOADING';
export const SET_ITEMS = '@app/orders/updateworkerstagesaga/SET_ITEMS';
export const CLEAR = '@app/orders/updateworkerstagesaga/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    errorStatus: '',
    data: []
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.data = payload.data;
                draft.success = true;
                break;
            case FAILURE:
                draft.errorStatus = payload;
                break;
            case SET_LOADING:
                draft.loading = payload;
                break;
            case CLEAR:
                draft.loading = false;
                draft.errorStatus = '';
                draft.data = null;
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Selectors
 */

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload: { worker, stage, withProfileRefetch = false, ...rest } }) {
        yield put(actions.clear());
        yield put(creator(SET_LOADING, true));
        try {
            const response = yield axios.put(`/workers/stage/${worker}`, {
                stage,
                ...rest
            });
            yield put(workersAction.stage_change(response.data.data));
            yield put(actions.success(response.data));
            if (withProfileRefetch) {
                yield put(profileActions.success(response.data));
            }
        } catch (e) {
            console.error(e);
            const error =
                (e.response && e.response.data && e.response.data.message) ||
                'Error: Something went wrong please contact support!';
            yield put(creator(CLEAR));
            yield put(actions.failure(error));
        }

        yield put(creator(SET_LOADING, false));
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
